<template>
  <div>
    <section class="sign-in-page">
      <b-container class="sign-in-page-bg mt-5 p-0">
        <div class="row no-gutters">
          <div class="col-md-6 text-center position-relative mobile-hide">
            <div class="sign-in-detail text-white">
              <a class="sign-in-logo mb-5" href="#"
              ><img :src="logo" alt="logo" class="logo-public"
              /></a>
              <Slick :option="slickOptions">
                <div class="item">
                  <img
                      :src="require('../../assets/images/login/1.png')"
                      alt="logo"
                      class="img-fluid mb-4"
                  />
                  <h4 class="mb-1 text-white">
                    {{ $t("public.layouts.AuthLayout.dot1Title") }}
                  </h4>
                  <p>
                    {{ $t("public.layouts.AuthLayout.dot1Text") }}
                  </p>
                </div>
                <div class="item">
                  <img
                      :src="require('../../assets/images/login/2.png')"
                      alt="logo"
                      class="img-fluid mb-4"
                  />
                  <h4 class="mb-1 text-white">
                    {{ $t("public.layouts.AuthLayout.dot2Title") }} 24/7
                  </h4>
                  <p>
                    {{ $t("public.layouts.AuthLayout.dot2Text") }}
                  </p>
                </div>
                <div class="item">
                  <img
                      :src="require('../../assets/images/login/3.png')"
                      alt="logo"
                      class="img-fluid mb-4"
                  />
                  <h4 class="mb-1 text-white">
                    {{ $t("public.layouts.AuthLayout.dot3Title") }}
                  </h4>
                  <p>
                    {{ $t("public.layouts.AuthLayout.dot3Text") }}
                  </p>
                </div>
                <div class="item">
                  <img
                      :src="require('../../assets/images/login/2.png')"
                      alt="logo"
                      class="img-fluid mb-4"
                  />
                  <h4 class="mb-1 text-white">
                    {{ $t("public.layouts.AuthLayout.dot4Title") }}
                  </h4>
                  <p>
                    {{ $t("public.layouts.AuthLayout.dot4Text") }}
                  </p>
                </div>
              </Slick>
              <footer-sign></footer-sign>
            </div>
          </div>
          <div class="col-md-6 position-relative">
            <div class="sign-in-from">
              <router-view></router-view>
            </div>
          </div>
        </div>
      </b-container>
    </section>
    <cookie-law>
      <div slot-scope="props">
        {{ $t("cookie.law.text") }}

        <div class="row">
          <div class="col-sm-12">
            <div class="text-center">
              <b-button
                  class="pull-center mr-2"
                  variant="success"
                  @click="props.accept"
              >
                {{ $t("cookie.law.btnAccept") }}
              </b-button>
              <!--       <b-button
                @click=""
                variant="warning"
                class="pull-center"
              >
                {{ $t("cookie.law.btnCookies") }}
              </b-button> -->
            </div>
          </div>
        </div>
      </div>
    </cookie-law>
  </div>
</template>
<script>
import logo from "../../assets/images/logo_public.png";
import {xray} from "../../config/pluginInit";
import bgImage from "../../assets/images/login/2.png";

import CookieLaw from "vue-cookie-law";

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default {
  name: "AuthLayout",
  components: {CookieLaw},
  mounted() {
    xray.index();
  },
  data() {
    return {
      slickOptions: {
        slidesToShow: 1,
        arrows: false,
        dots: true,
      },

      logo: logo,
      bgImageURL: bgImage,
    };
  },
};
</script>
